import { getBorderBase, getFontBase, getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

const prefix = ['components', 'switchInput'];

export const Body = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 12px;
  border-style: solid;
`;

export const Label = styled.div``;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
`;

export const Error = styled.div`
  margin-top: 2px;
  min-height: 18px;
`;

export const Container = styled.div<{ $size: 'lg' | 'sm'; $withLabelGap?: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ $size }) => css`
    ${Body} {
      flex: 1 1 auto;
      padding: ${$size === 'sm' ? 5 : 11}px 8px;
      background: ${getPrefixedVar(prefix, $size, 'bg')};
      ${getBorderBase([...prefix, $size])}
    }

    ${Label} {
      ${getFontBase([...prefix, $size])};
    }

    ${Error} {
      ${getFontBase([...prefix, $size, 'error'])};
    }
  `};

  ${({ $withLabelGap }) =>
    $withLabelGap &&
    css`
      margin-top: 24px;
    `};
`;
